import React, { useState } from 'react';
import { useProducts } from '../context/ProductsContext';
import { FiPlus, FiX, FiPrinter, FiShare2 } from 'react-icons/fi';
import jsPDF from 'jspdf';

const BUSINESS = {
  name: 'Shammy Spices',
  phone: '+255 655 778 989',
  address: 'Dar es Salaam, Tanzania',
};

let receiptCounter = Number(localStorage.getItem('shammy_rec_counter') || 100);
const nextReceiptNo = () => {
  receiptCounter++;
  localStorage.setItem('shammy_rec_counter', receiptCounter);
  return `REC-${receiptCounter}`;
};

const AdminReceipt = () => {
  const { products } = useProducts();
  const [customerName, setCustomerName] = useState('');
  const [lines, setLines] = useState([{ productId: '', name: '', price: 0, qty: 1 }]);
  const [receiptNo] = useState(() => nextReceiptNo());
  const [date] = useState(() => new Date().toLocaleDateString('en-GB'));
  const [payMethod, setPayMethod] = useState('Cash');

  const setLine = (i, key, val) => {
    setLines(prev => prev.map((l, idx) => idx === i ? { ...l, [key]: val } : l));
  };

  const selectProduct = (i, productId) => {
    const p = products.find(p => String(p.id) === productId);
    if (p) setLines(prev => prev.map((l, idx) => idx === i ? { ...l, productId, name: p.name, price: p.price } : l));
    else setLine(i, 'productId', productId);
  };

  const addLine = () => setLines(prev => [...prev, { productId: '', name: '', price: 0, qty: 1 }]);
  const removeLine = (i) => setLines(prev => prev.filter((_, idx) => idx !== i));

  const total = lines.reduce((s, l) => s + (Number(l.price) * Number(l.qty)), 0);

  const handlePDF = () => {
    const doc = new jsPDF({ unit: 'mm', format: [80, 200] });
    const w = 80;
    let y = 10;

    doc.setFontSize(14); doc.setTextColor('#1a4f0c');
    doc.text(BUSINESS.name, w / 2, y, { align: 'center' }); y += 6;
    doc.setFontSize(8); doc.setTextColor('#555');
    doc.text(BUSINESS.phone, w / 2, y, { align: 'center' }); y += 4;
    doc.text(BUSINESS.address, w / 2, y, { align: 'center' }); y += 6;

    doc.setDrawColor('#ccc'); doc.setLineWidth(0.3);
    doc.line(5, y, w - 5, y); y += 5;

    doc.setFontSize(9); doc.setTextColor('#1a1a1a');
    doc.text(`Receipt: ${receiptNo}`, 5, y); y += 4;
    doc.text(`Date: ${date}`, 5, y); y += 4;
    doc.text(`Payment: ${payMethod}`, 5, y); y += 4;
    if (customerName) { doc.text(`Customer: ${customerName}`, 5, y); y += 4; }

    doc.line(5, y, w - 5, y); y += 5;

    lines.filter(l => l.name || l.productId).forEach(l => {
      const name = l.name || products.find(p => String(p.id) === l.productId)?.name || '';
      doc.setFontSize(8);
      doc.text(`${name} x${l.qty}`, 5, y); y += 4;
      doc.text(`TZS ${(Number(l.price) * Number(l.qty)).toLocaleString()}`, w - 5, y - 4, { align: 'right' });
    });

    y += 2;
    doc.line(5, y, w - 5, y); y += 5;
    doc.setFontSize(11); doc.setTextColor('#1a4f0c');
    doc.text(`TOTAL: TZS ${total.toLocaleString()}`, w / 2, y, { align: 'center' }); y += 8;

    doc.setFontSize(8); doc.setTextColor('#999');
    doc.text('Thank you!', w / 2, y, { align: 'center' });

    doc.save(`${receiptNo}.pdf`);
  };

  const handleShare = () => {
    const text = `*${BUSINESS.name} — Receipt ${receiptNo}*\nDate: ${date}\nPayment: ${payMethod}\n` +
      (customerName ? `Customer: ${customerName}\n` : '') + '\n' +
      lines.filter(l => l.name || l.productId).map(l => {
        const name = l.name || products.find(p => String(p.id) === l.productId)?.name || '';
        return `• ${name} x${l.qty} = TZS ${(Number(l.price) * Number(l.qty)).toLocaleString()}`;
      }).join('\n') +
      `\n\n*TOTAL: TZS ${total.toLocaleString()}*`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  return (
    <div className="ap-page">
      <div className="ap-page-header">
        <h1 className="ap-page-title">Receipt</h1>
        <span className="ap-inv-no">{receiptNo}</span>
      </div>

      <div className="ap-inv-section">
        <h3 className="ap-section-label">Customer (optional)</h3>
        <input className="ap-input" placeholder="Customer name" value={customerName}
          onChange={e => setCustomerName(e.target.value)} />
        <div className="ap-pay-methods">
          {['Cash', 'M-Pesa', 'Tigo Pesa', 'Airtel Money', 'Bank Transfer'].map(m => (
            <button key={m} className={`ap-pay-chip ${payMethod === m ? 'active' : ''}`}
              onClick={() => setPayMethod(m)}>{m}</button>
          ))}
        </div>
      </div>

      <div className="ap-inv-section">
        <h3 className="ap-section-label">Items Sold</h3>
        {lines.map((line, i) => (
          <div key={i} className="ap-line-row">
            <div className="ap-line-product">
              <select className="ap-input ap-line-select" value={line.productId}
                onChange={e => selectProduct(i, e.target.value)}>
                <option value="">— Select product —</option>
                {products.map(p => <option key={p.id} value={p.id}>{p.name} — TZS {Number(p.price).toLocaleString()}</option>)}
                <option value="custom">Custom item...</option>
              </select>
              {line.productId === 'custom' && (
                <input className="ap-input mt-4" placeholder="Item name" value={line.name}
                  onChange={e => setLine(i, 'name', e.target.value)} />
              )}
            </div>
            <div className="ap-line-controls">
              <input className="ap-input ap-line-price" type="number" placeholder="Price"
                value={line.price} onChange={e => setLine(i, 'price', e.target.value)} />
              <div className="ap-line-qty-wrap">
                <button className="ap-qty-btn" onClick={() => setLine(i, 'qty', Math.max(1, line.qty - 1))}>−</button>
                <span className="ap-qty-val">{line.qty}</span>
                <button className="ap-qty-btn" onClick={() => setLine(i, 'qty', line.qty + 1)}>+</button>
              </div>
              <span className="ap-line-total">{(Number(line.price) * Number(line.qty)).toLocaleString()}</span>
              {lines.length > 1 && (
                <button className="ap-icon-btn del" onClick={() => removeLine(i)}><FiX /></button>
              )}
            </div>
          </div>
        ))}
        <button className="ap-add-line" onClick={addLine}><FiPlus /> Add Item</button>
      </div>

      <div className="ap-inv-total-bar">
        <span>Total</span>
        <strong>TZS {total.toLocaleString()}</strong>
      </div>

      <div className="ap-inv-actions">
        <button className="ap-inv-btn pdf" onClick={handlePDF}><FiPrinter /> Download PDF</button>
        <button className="ap-inv-btn whatsapp" onClick={handleShare}><FiShare2 /> Share via WhatsApp</button>
      </div>
    </div>
  );
};

export default AdminReceipt;
